var React = require('react');

function ActiveInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"12","fill":"#7C8D90","key":0}),React.createElement("path",{"d":"M11.25 16.9412C11.25 17.3554 11.5858 17.6912 12 17.6912C12.4142 17.6912 12.75 17.3554 12.75 16.9412L11.25 16.9412ZM12.5303 7.23436C12.2374 6.94147 11.7626 6.94147 11.4697 7.23436L6.6967 12.0073C6.40381 12.3002 6.40381 12.7751 6.6967 13.068C6.98959 13.3609 7.46447 13.3609 7.75736 13.068L12 8.82535L16.2426 13.068C16.5355 13.3609 17.0104 13.3609 17.3033 13.068C17.5962 12.7751 17.5962 12.3002 17.3033 12.0073L12.5303 7.23436ZM12.75 16.9412L12.75 7.76469L11.25 7.76469L11.25 16.9412L12.75 16.9412Z","fill":"white","key":1})]);
}

ActiveInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ActiveInline;

ActiveInline.default = ActiveInline;
